var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFinancialGrowth = function SvgFinancialGrowth(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 21.384439,
    x2: 86,
    y2: 91.259438,
    gradientTransform: "matrix(0.372093,0,0,0.372093,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(40.392157%,93.725491%,92.54902%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(49.803922%,92.941177%,76.862746%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 10.234,
    x2: 86,
    y2: 159.234375,
    gradientTransform: "matrix(0.372093,0,0,0.372093,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 86,
    y1: 10.234,
    x2: 86,
    y2: 159.234375,
    gradientTransform: "matrix(0.372093,0,0,0.372093,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(8.627451%,81.568629%,80.000001%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(12.156863%,86.666667%,58.431375%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface471007"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 32 36 C 24.832031 36 19 30.167969 19 23 C 19 15.832031 24.832031 10 32 10 C 39.167969 10 45 15.832031 45 23 C 45 30.167969 39.167969 36 32 36 Z M 32 12 C 25.933594 12 21 16.933594 21 23 C 21 29.066406 25.933594 34 32 34 C 38.066406 34 43 29.066406 43 23 C 43 16.933594 38.066406 12 32 12 Z M 32 12 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 49 40 C 49 41.652344 47.652344 43 46 43 L 40 43 C 37.175781 43 34.652344 44.3125 33 46.355469 L 33 39.949219 C 41.90625 39.425781 49 32.035156 49 23 C 49 13.625 41.375 6 32 6 C 22.625 6 15 13.625 15 23 C 15 32.035156 22.09375 39.425781 31 39.949219 L 31 46.355469 C 29.347656 44.3125 26.824219 43 24 43 L 18 43 C 16.347656 43 15 41.652344 15 40 L 13 40 L 13 44 C 13 48.964844 17.039062 53 22 53 L 28 53 C 29.652344 53 31 54.347656 31 56 L 31 58 L 33 58 L 33 56 C 33 54.347656 34.347656 53 36 53 L 42 53 C 46.960938 53 51 48.964844 51 44 L 51 40 Z M 17 23 C 17 14.730469 23.730469 8 32 8 C 40.269531 8 47 14.730469 47 23 C 47 31.269531 40.269531 38 32 38 C 23.730469 38 17 31.269531 17 23 Z M 28 51 L 22 51 C 18.140625 51 15 47.859375 15 44 L 15 43.972656 C 15.839844 44.609375 16.871094 45 18 45 L 24 45 C 27.859375 45 31 48.140625 31 52 L 31 52.027344 C 30.160156 51.390625 29.128906 51 28 51 Z M 42 51 L 36 51 C 34.871094 51 33.839844 51.390625 33 52.027344 L 33 52 C 33 48.140625 36.140625 45 40 45 L 46 45 C 47.128906 45 48.160156 44.609375 49 43.972656 L 49 44 C 49 47.859375 45.859375 51 42 51 Z M 42 51 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 33 31 L 33 29 L 35 29 C 36.652344 29 38 27.65625 38 26 L 38 25 C 38 23.347656 36.652344 22 35 22 L 29 22 C 28.449219 22 28 21.550781 28 21 L 28 19 C 28 18.449219 28.449219 18 29 18 L 37 18 L 37 16 L 33.003906 16 L 33 14 L 31 14.003906 L 31.003906 16 L 29 16 C 27.347656 16 26 17.347656 26 19 L 26 21 C 26 22.65625 27.347656 24 29 24 L 35 24 C 35.550781 24 36 24.449219 36 25 L 36 26 C 36 26.550781 35.550781 27 35 27 L 26 27 L 26 29 L 31 29 L 31 31 Z M 33 31 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFinancialGrowth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/financial-growth.485008be.svg";
export { ForwardRef as ReactComponent };